const size = {
    mobile: '600px',
    mobileS: '330px',
    mobileLanscape: '900px',
    mobileSLanscape: '600px',
    standardHeight: '640px',
    bigScreen: '1800px',
	mediumScreen: '1200px'
};

const { mobile, mobileS, standardHeight, bigScreen, mobileLanscape, mobileSLanscape, mediumScreen } = size;

export const resolutions = {
    forMobile: `(max-width: ${mobile})`,
    forMobileS: `(max-width: ${mobileS}) and (max-height: ${standardHeight})`,
    forMobileLanscape: `(max-width: ${mobileLanscape}) and (orientation: landscape)`,
    forMobileSLanscape: `(max-width: ${mobileSLanscape}) and (orientation: landscape)`,
	forMediumScreen: `(max-width: ${mediumScreen})`,
    bigScreen: `(min-width: ${bigScreen})`
};
